import React, { Component } from 'react';
import { Table, Row, Col, Alert, Button, DatePicker, message, Spin, Input } from 'antd';
import moment from 'moment';
import { data7_1_2 } from './data';
import imgSave from "../../saveImg";
import Auth from "../../Auth";
import IsLableAuth from "../../IsLableAuth";
import { correspond } from './compute';
import { calculation } from '../../../../method';
import Chart from './chart'
import { getChart } from './chart/chart'
const { MonthPicker } = DatePicker;

class index extends Component {
    constructor(props) {
        super(props);
        this.state = {
            date: moment().subtract(1, 'month').format('YYYY-MM'),
            data: [],
            loading: true,
            note: { note: "" },
            loadingSave: false,
            print: false
        }
    }


    componentDidMount() {
        this.getDateData(this.state.date);
    }



    computeNum = (data) => {
        // 薪酬合计
        const totalData = ['thisy_employee_num', 'thisy_payroll_cost', 'lasty_employee_num', 'lasty_payroll_cost', 'year_thisy_employee_num', 'year_thisy_payroll_cost', 'year_lasty_employee_num', 'year_lasty_payroll_cost']

        for (let index = 0; index < totalData.length; index++) {
            data[7][totalData[index]] = 0;
        }

        for (let index = 0; index < 7; index++) {
            for (let i = 0; i < totalData.length; i++) {
                if (index != 6) data[7][totalData[i]] = Number(data[index][totalData[i]]) + Number(data[7][totalData[i]]);
            }
        }
        let toFixedData = {
            7: ['thisy_employee_num', 'thisy_payroll_cost', 'lasty_employee_num', 'lasty_payroll_cost', 'year_thisy_employee_num', 'year_thisy_payroll_cost', 'year_lasty_employee_num', 'year_lasty_payroll_cost'],

        }
        for (const key in toFixedData) {
            if (toFixedData.hasOwnProperty(key)) {
                for (let index = 0; index < toFixedData[key].length; index++) {
                    data[key][toFixedData[key][index]] = data[key][toFixedData[key][index]].toFixed(1);
                }
            }
        }

        // 计算百分比  **对比**
        for (let index = 0; index < data.length; index++) {
            // data[index].thisy_average_payroll = Number((Number(data[index].thisy_employee_num || "0") ? Number(data[index].thisy_payroll_cost || "0") / Number(data[index].thisy_employee_num || "0") : 0).toFixed(1));
            // data[index].lasty_average_payroll = Number((Number(data[index].lasty_employee_num || "0") ? Number(data[index].lasty_payroll_cost || "0") / Number(data[index].lasty_employee_num || "0") : 0).toFixed(1))
            data[index].variance_emplyee_num = Number((data[index].thisy_employee_num - data[index].lasty_employee_num).toFixed(1));
            data[index].ven_percent = Number((Number(data[index].lasty_employee_num || "0") ? Number(data[index].variance_emplyee_num || "0") / Number(data[index].lasty_employee_num || "0") : 0).toFixed(3))
            data[index].variance_average_payroll = Number((data[index].thisy_average_payroll - data[index].lasty_average_payroll).toFixed(1));
            data[index].vap_percent = Number((Number(data[index].lasty_average_payroll || "0") ? Number(data[index].variance_average_payroll || "0") / Number(data[index].lasty_average_payroll || "0") : 0).toFixed(3));
            data[index].variance_payroll = Number((data[index].thisy_payroll_cost - data[index].lasty_payroll_cost).toFixed(1));
            data[index].vp_percent = Number((Number(data[index].lasty_payroll_cost || "0") ? Number(data[index].variance_payroll || "0") / Number(data[index].lasty_payroll_cost || "0") : 0).toFixed(3))

            // 年累计
            // data[index].year_thisy_average_payroll = Number((Number(data[index].year_thisy_employee_num || "0") ? Number(data[index].year_thisy_payroll_cost || "0") / Number(data[index].year_thisy_employee_num || "0") : 0).toFixed(1));
            // data[index].year_lasty_average_payroll = Number((Number(data[index].year_lasty_employee_num || "0") ? Number(data[index].year_lasty_payroll_cost || "0") / Number(data[index].year_lasty_employee_num || "0") : 0).toFixed(1))
            data[index].year_variance_emplyee_num = Number((data[index].year_thisy_employee_num - data[index].year_lasty_employee_num).toFixed(1));
            data[index].year_ven_percent = Number((Number(data[index].year_lasty_employee_num || "0") ? Number(data[index].year_variance_emplyee_num || "0") / Number(data[index].year_lasty_employee_num || "0") : 0).toFixed(3))
            data[index].year_variance_average_payroll = Number((data[index].year_thisy_average_payroll - data[index].year_lasty_average_payroll).toFixed(1));
            data[index].year_vap_percent = Number((Number(data[index].year_lasty_average_payroll || "0") ? Number(data[index].year_variance_average_payroll || "0") / Number(data[index].year_lasty_average_payroll || "0") : 0).toFixed(3));
            data[index].year_variance_payroll = Number((data[index].year_thisy_payroll_cost - data[index].year_lasty_payroll_cost).toFixed(1));
        }

        data[7].thisy_average_payroll = calculation(
            data[7].thisy_payroll_cost,
            data[7].thisy_employee_num
        );

        data[7].year_thisy_average_payroll = calculation(
            data[7].year_thisy_payroll_cost,
            data[7].year_thisy_employee_num
        );

        this.setState({
            data
        }, () => {
            this.onSave();
        });

    }
    onChange = (name, value, i) => {
        let data = this.state.data;
        data[i][name] = value;
        this.computeNum(data);
    }

    getDateData = (date) => {
        const dataBegin = JSON.stringify(data7_1_2);
        let data = JSON.parse(dataBegin);

        fetch(`/_7_4_1_info?year=${moment(date).format('YYYY')}&month=${moment(date).format('M')}`, { credentials: 'include' }).then(x => x.json()).then(x => {
            if (x.data.data && x.data.data.length > 0) {
                data = x.data.data;
            }
            this.setState({ loading: false, note: { note: "", ...x.data.note } });
            this.computeNum(correspond({ ...x.data, data }));
        }).catch(err => {
            this.setState({ loading: false });
            console.error(err);
        })
    }

    onSave = () => {
        this.setState({ loadingSave: true });
        let date = this.state.date;
        if (!date) {
            message.error('请选择年份月份');
            let timer = setTimeout(() => { this.setState({ loadingSave: false }); clearTimeout(timer) }, 1000)
            return
        }
        let year = moment(date).format("YYYY");
        let month = moment(date).format("M");
        let data = this.state.data.map(x => ({ ...x, year, month }));
        let dataFrom = new FormData();
        dataFrom.append('data', JSON.stringify(data));
        let headres = {
            method: 'post',
            credentials: 'include',
            headers: {},
            body: dataFrom
        }

        fetch('/add_7_4_1', headres).then(x => x.json()).then(x => {
            let timer = setTimeout(() => { this.setState({ loadingSave: false }); clearTimeout(timer) }, 1000)
            if (x.status == 1) {
                message.success(x.msg);
                if (!data[0].id) {
                    this.getDateData(this.state.date);
                }
                getChart(year);
                return
            }
            message.error(x.msg);
        }).catch(err => {
            message.error('保存失败' + JSON.stringify(err));
            let timer = setTimeout(() => { this.setState({ loadingSave: false }); clearTimeout(timer) }, 1000)
            console.error(err);
        })
    }

    downloadSG = () => {

        this.setState({ print: true, loading: true }, () => {
            imgSave('table7_4', 1.5, '7.40', this.state.date).then(x => {
                if (x.status == 1) {
                    message.info('添加成功！');
                } else {
                    message.error('添加失败' + x.msg);
                }

                this.setState({
                    print: false,
                    loading: false
                });
            }).catch(err => {
                console.error(err);
                this.setState({
                    print: false,
                    loading: false
                });
            })

        });

    }

    render() {
        const { data } = this.state;
        const columns = [{
            title: 'Department 部门',
            dataIndex: 'name',
            key: 'name',
            align: "center",
            // fixed: "left",
            width: 300,
            render: (text, record, index) => {
                if (index == 6) return {
                    props: {
                        rowSpan: 0
                    }
                }
                return (
                    <div className={`table-padding ${index == 7 || index == 15 || index == 16 ? 'table-color-footer' : ''}`} style={{ textAlign: "left" }}>
                        {text}
                    </div>
                )
            }
        }, {
            title: 'Current Month 本年当月',
            align: "center",
            width: 1800,
            children: [{
                align: "center",
                title: 'Current Month Actual - This Year 本年当月实际数',
                width: 450,
                children: [{
                    title: <div>No. of Participants <br />受训人数</div>,
                    dataIndex: 'thisy_employee_num',
                    key: 'thisy_employee_num',
                    align: "center",
                    width: 150,
                    render: (text, record, index) => {
                        if (index == 6) return {
                            props: {
                                rowSpan: 0
                            }
                        }
                        return (
                            <div className={`table-padding ${index == 7 || index == 15 || index == 16 ? 'table-color-footer' : ''}`}>
                                {text.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                            </div>
                        )
                    }
                }, {
                    title: <div>Average Training Hours<br />人均受训时间</div>,
                    dataIndex: 'thisy_average_payroll',
                    key: 'thisy_average_payroll',
                    align: "center",
                    width: 150,
                    render: (text, record, index) => {
                        if (index == 6) return {
                            props: {
                                rowSpan: 0
                            }
                        }
                        return (
                            <div className={`table-padding ${index == 7 || index == 15 || index == 16 ? 'table-color-footer' : ''}`} >
                                {text.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                            </div>
                        )
                    }
                }, {
                    title: <div>Total Training Hours <br />培训时间总计</div>,
                    dataIndex: 'thisy_payroll_cost',
                    key: 'thisy_payroll_cost',
                    align: "center",
                    width: 150,
                    render: (text, record, index) => {
                        if (index == 6) return {
                            props: {
                                rowSpan: 0
                            }
                        }
                        return (
                            <div className={`table-padding ${index == 7 || index == 15 || index == 16 ? 'table-color-footer' : ''}`} >
                                {text.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                            </div>
                        )
                    }
                }]
            }
            ],
        }, {
            title: 'YTD 年累计',
            align: "center",
            width: 1650,
            children: [{
                align: "center",
                title: 'YTD Actual - This Year 年累计实际 - 今年',
                width: 450,
                children: [{
                    title: <div>No. of Participants <br />受训人数</div>,
                    dataIndex: 'year_thisy_employee_num',
                    key: 'year_thisy_employee_num',
                    align: "center",
                    width: 150,
                    render: (text, record, index) => {
                        if (index == 6) return {
                            props: {
                                rowSpan: 0
                            }
                        }
                        return (
                            <div className={`table-padding ${index == 7 || index == 15 || index == 16 ? 'table-color-footer' : ''}`}>
                                {text.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                            </div>
                        )

                    }
                }, {
                    title: <div>Average Training Hours<br />人均受训时间</div>,
                    dataIndex: 'year_thisy_average_payroll',
                    key: 'year_thisy_average_payroll',
                    align: "center",
                    width: 150,
                    render: (text, record, index) => {
                        if (index == 6) return {
                            props: {
                                rowSpan: 0
                            }
                        }
                        return (
                            <div className={`table-padding ${index == 7 || index == 15 || index == 16 ? 'table-color-footer' : ''}`} >
                                {text.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                            </div>
                        )
                    }
                }, {
                    title: <div>Total Training Hours <br />培训时间总计</div>,
                    dataIndex: 'year_thisy_payroll_cost',
                    key: 'year_thisy_payroll_cost',
                    align: "center",
                    width: 150,
                    render: (text, record, index) => {
                        if (index == 6) return {
                            props: {
                                rowSpan: 0
                            }
                        }
                        return (
                            <div className={`table-padding ${index == 7 || index == 15 || index == 16 ? 'table-color-footer' : ''}`} >
                                {text.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                            </div>
                        )

                    }
                }]
            }],
        }];

        return (
            <Spin spinning={this.state.loading}>
                <div className="table7_1_1">
                    <Row className="title" id="table7_4" style={{ width: this.state.print ? 3800 : 'auto' }}>
                        <Row>7.4 Training Statistics By Department 按部门培训记录统计</Row>
                        <Row className="table-month">
                            <MonthPicker
                                placeholder="请选择年月"
                                monthCellContentRender={(date, local) => {
                                    return moment(date).format('M月')
                                }}
                                defaultValue={moment(this.state.date, "YYYY-MM")}
                                format="YYYY-MM"
                                onChange={(date, str) => {
                                    this.setState({
                                        date: str,
                                        data: [],
                                        loading: true,
                                        note: { note: "" }
                                    });
                                    this.getDateData(str)
                                }}
                            />
                        </Row>
                        <Table
                            columns={columns}
                            dataSource={data}
                            size="middle"
                            bordered
                            pagination={false}
                            className="content"
                            rowKey={(record, index) => index}
                        />
                    </Row>
                    <Auth loading={this.state.loading} auth="edit_7_4">
                        <Row className="table-footer-btn">
                            <Alert
                                message={
                                    <div>
                                        表格关联
                                        <IsLableAuth auth="read_4_1" {...this.props} path="/hr/4_1">HR 4.1.3</IsLableAuth>
                                    </div>
                                }
                                type="info"
                                showIcon
                                style={{ display: "inline-block", marginRight: 10 }}
                            />
                            <Button
                                type="primary"
                                style={{ marginRight: 10 }}
                                onClick={this.downloadSG}
                                loading={this.state.print}
                            >加入pdf</Button>
                            <Button
                                type="primary"
                                onClick={this.onSave}
                                loading={this.state.loadingSave}
                            >保存</Button>
                        </Row>
                    </Auth>

                    <Chart />
                </div>
            </Spin >
        );
    }
}

export default index;


// WEBPACK FOOTER //
// ./src/components/table/7-HumanResourcesAnalysis/7-4/index.js